import {
  styled,
  TextareaAutosize,
  type TextareaAutosizeProps,
} from '@mui/material';

type CustomTextareaAutosizeProps = Omit<TextareaAutosizeProps, 'variant'>;

export const CustomTextareaAutosize = styled(
  (props: CustomTextareaAutosizeProps) => <TextareaAutosize {...props} />,
)(({ theme }) => ({
  position: 'relative',
  padding: 10,
  borderRadius: 10,
  border: 'none',
  fontSize: 13,
  backgroundColor: theme.palette.gray100.main,
  marginTop: 0,
  minWidth: 0,
  color: theme.palette.gray500.main,
  boxSizing: 'border-box',
  fontFamily: theme.typography.fontFamily,

  '&:disabled': {
    backgroundColor: '#F9F9FA',
    borderColor: '#D8DBDF',
    WebkitTextFillColor: '#B1B8BF',
    color: '#B1B8BF',
  },

  '&:read-only': {
    borderColor: 'transparent',
    backgroundColor: '#F9F9FA',
  },

  '&::placeholder': {
    color: theme.palette.gray500.main,
    opacity: 1,
  },
}));
